/*
  Scroll reveal, site-wide.

  What this replaces: the previous version force-added `in` and `is-in` to every
  element inside every bn-* section, three times over. It was written as a safety net
  against content getting stuck invisible, but because it fired at DOMContentLoaded it
  pre-revealed the whole page, which silently disabled every scroll animation on the
  site. Alcalina looked like the only page that animated purely because its gpt-*
  sections used a root class the sweep did not match.

  How this version stays safe. The hiding styles in bn-brand.css are gated behind
  `html.bn-motion`, and only this script adds that class. If the script never runs,
  throws, is blocked, or the browser lacks IntersectionObserver, nothing is ever
  hidden. On top of that there are timed catch-up passes, so an element cannot stay
  hidden because an observer failed to fire on a very tall section.

  Sections with their own observers (chooser, clarity, protocolnext, routine,
  structure and others) are untouched: they drive their own class names. Where they
  also carry `.bn-reveal`, adding `is-in` twice is idempotent, so nothing animates
  twice.
*/
(function () {
  var docEl = document.documentElement;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced || !('IntersectionObserver' in window)) {
    // Never arm. Content stays visible and unanimated, which is the correct outcome.
    return;
  }

  // The head snippet already armed this before first paint and set a 2.5s failsafe
  // that disarms if we never boot. Claim it now so the failsafe stands down, and
  // re-add for the case where the head snippet is absent.
  docEl.classList.add('bn-motion');
  docEl.setAttribute('data-bn-reveal-ready', '1');

  var SEL = '.bn-reveal';
  var seen = typeof WeakSet === 'function' ? new WeakSet() : null;

  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].isIntersecting) {
        entries[i].target.classList.add('is-in');
        io.unobserve(entries[i].target);
      }
    }
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  function scan() {
    var els = document.querySelectorAll(SEL);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.classList.contains('is-in')) continue;
      if (seen) {
        if (seen.has(el)) continue;
        seen.add(el);
      }
      io.observe(el);
    }
  }

  // Anything already within the first screens is revealed without waiting for a
  // scroll, so the top of the page is never blank on arrival.
  function revealNear(multiplier) {
    var els = document.querySelectorAll(SEL + ':not(.is-in)');
    var limit = window.innerHeight * multiplier;
    for (var i = 0; i < els.length; i++) {
      if (els[i].getBoundingClientRect().top < limit) els[i].classList.add('is-in');
    }
  }

  function boot() {
    scan();
    revealNear(1);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('load', function () { scan(); revealNear(1); });

  // Late DOM: Loox reviews, YouTube facades, theme-editor re-renders.
  setTimeout(function () { scan(); revealNear(1.5); }, 1400);

  // Last-resort catch-up. If an observer never fired for something the shopper has
  // plausibly reached, show it rather than leave a hole. Deliberately generous so it
  // does not pre-reveal the whole page and flatten the effect.
  setTimeout(function () { scan(); revealNear(2.5); }, 4000);

  // Theme editor: sections re-render on every setting change and arrive unobserved.
  document.addEventListener('shopify:section:load', function () {
    scan();
    revealNear(1.5);
  });
})();
